__webpack_require__.p = "/minside/";